// Try to use MaxRecordSeconds value from DeafUserInformationResponse when calls will be available, for now this value is hardcoded
// 2 minutes
export const maxVideoRecordingDuration = 1000 * 120;
